<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-container>
            <v-layout pa-3 v-if="bill" wrap>
              <v-flex xs12>
                <router-link to="/delivery-shopping-list">
                  <i class="zmdi zmdi-long-arrow-left zmdi-hc-2x"></i>
                </router-link>
              </v-flex>

              <v-flex xs12 :class="classDelivered">
                <h3>{{ $t('message.status') }}</h3>

                <purchase-status :purchaseStatusId.sync="bill.purchase_status_id"></purchase-status>

                </v-flex>

              <v-flex xs12 md6 v-if="bill.purchase_status_id != purchaseStatus.PURCHASE_DELIVERED">
                <h3>{{ $t('message.info') }}</h3>

                <v-alert v-if="bill.company" :value="true" color="warning" icon="info" outline>
                  La compra sera retirada por
                  <strong>{{ bill.company.name }}</strong>
                </v-alert>

                <v-alert
                  v-else
                  :value="true"
                  color="warning"
                  icon="info"
                  outline
                >La compra sera retirada en persona</v-alert>
              </v-flex>

              <v-flex xs12 :class="classObject">
                <h3>{{ $t('message.client') }}</h3>

                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field readonly :label="$t('message.name')" v-model="bill.client.name"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.lastname')"
                      v-model="bill.client.lastname"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 md6 v-if="bill.dealer">
                <h3>{{ $t('message.dealer') }}</h3>

                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.name')"
                      v-model="bill.dealer.dealer.name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.lastname')"
                      v-model="bill.dealer.dealer.lastname"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="bill.company" xs12 md6>
                <h3>{{ $t('message.deliveryCompany')}}</h3>
                <v-layout>
                  <v-flex>
                    <v-text-field readonly :label="$t('message.name')" v-model="bill.company.name"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <h3>Método de pago</h3>
                <v-textarea no-resize :rows="2" readonly label :value="bill.note"></v-textarea>
              </v-flex>

              <v-flex v-if="bill.invoice.length" xs12>
                <h3>Factura</h3>

                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.name')"
                      v-model="bill.invoice[0].name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.lastname')"
                      v-model="bill.invoice[0].lastname"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.identification')"
                      v-model="bill.invoice[0].identification"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.telephone')"
                      v-model="bill.invoice[0].phone"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.email')"
                      v-model="bill.invoice[0].email"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      readonly
                      :label="$t('message.city')"
                      v-model="bill.invoice[0].city"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <h3>{{ $t('message.receiptImage') }}</h3>
                <v-img
                  :src="bill.full_url_image"
                  @click="onReceipt"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  max-height="200"
                ></v-img>
              </v-flex>

              <v-flex v-if="hasLocation" xs12>
                <h3>{{ $t('message.deliveryAddress') }}</h3>
                <l-map :center="center" :zoom="zoom" class="map-style mb-3">
                  <l-marker :lat-lng="marker"></l-marker>
                  <l-tile-layer :url="url"></l-tile-layer>
                </l-map>

                <v-layout row wrap>
                  <v-flex v-show="bill.address_reference" xs12 md8>
                    <v-textarea
                      disabled
                      dense
                      :label="$t('message.addressReference')"
                      v-model="bill.address_reference"
                      auto-grow
                      :rows="2"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 md4>
                    <a round
                      :href="`https://www.google.com/maps/?q=${marker[0]},${marker[1]}`"
                      target="_blank">
                      <v-btn block color="primary">Ver en Google Maps 🗺️</v-btn>
                    </a>
                  </v-flex>
                </v-layout>
              </v-flex>
              
              <v-flex xs12 v-if="bill.details">
                <h3>{{ $t('message.order') }}</h3>
                
                <v-data-table :headers="headers" :items="productAndExtras" hide-actions>
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                      <span>{{ $t(`message.${props.header.text}`) }}</span>
                    </v-tooltip>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.price + ' $' }}</td>
                    <td>{{ props.item.quantity }}</td>
                    <td>{{ props.item.observation || "Ninguna" }}</td>
                    <td class="text-left">{{ (props.item.quantity * props.item.price).toFixed(2) + ' $' }}</td>
                  </template>
                </v-data-table>

              </v-flex>


              <v-flex xs12>
                <v-layout pa-3>
                  <v-flex v-if="bill.dollar_price">
                    <p>
                      <strong>{{ $t('message.exchangeRate') }}: </strong>
                      {{ Number(bill.dollar_price).toLocaleString('de-DE', { style: 'currency', currency: 'VES' }) }}
                    </p>
                    <p>
                      <strong>{{ $t('message.totalInVes') }}: </strong>
                      {{ (totalPrice() * bill.dollar_price).toLocaleString('de-DE', { style: 'currency', currency: 'VES' }) }}
                    </p>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <p v-if="bill.delivery_price">
                      <strong>{{ $t('message.deliveryCost') }}: </strong>
                      {{ `${Number(bill.delivery_price).toFixed(2)} $`}}
                    </p>
                    <p>
                      <strong>{{ $t('message.totalToPay') }}: </strong>
                      {{ `${totalPrice().toFixed(2)} $` }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 v-if="bill.purchase_status_id == purchaseStatus.PURCHASE_SHIPPED">
                <v-layout justify-end>
                  <v-flex shrink>
                    <v-btn
                      outline
                      @click="onConfirmDelivery"
                      :loading="confirmDeliveryLoading"
                      color="primary"
                    >{{ $t('message.confirmDelivery') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 v-if="bill.payment_to_delivey && bill.purchase_status_id == purchaseStatus.PURCHASE_NOT_VERIFIED">
                <v-layout justify-end>
                  <v-flex shrink>
                    <v-btn outline @click="onDenyPayment" color="error">{{ $t('message.deny') }}</v-btn>
                  </v-flex>
                  <v-flex shrink>
                    <v-btn
                      outline
                      @click="onConfirmPayment"
                      :loading="confirmPaymentLoading"
                      color="primary"
                    >{{ $t('message.confirmPayment') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
          </v-container>
        </app-card>
      </v-layout>
      <receipt-image :dialog.sync="openReceiptModal" ref="receiptModal"></receipt-image>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userRoles, purchaseStatus } from "../../../constants/constants";
import PurchaseStatus from '../../custom/PurchaseStatus';
import {
  GET_SHOPPING,
  CONFIRM_PAYMENT,
  CONFIRM_DELIVERY,
  DENY_SHOPPING
} from "../../../store/modules/shoppings/actions.type";
import ReceiptImage from "../ReceiptImage";

const initLat = 47.41322;
const initLng = -1.219482;

export default {
  name: "shoppingDetails",
  components: {
    ReceiptImage,
    PurchaseStatus,
  },
  data() {
    return {
      confirmPaymentLoading: false,
      confirmDeliveryLoading: false,
      bill: null,
      billId: null,
      productAndExtras: [],
      headers: [
        { text: "name", sortable: false, align: "center", value: "name" },
        { text: "price", sortable: false, align: "center", value: "price" },
        { text: "quantity", sortable: false, align: "center", value: "quantity" },
        { text: "observation", sortable: false, align: "center", value: "observation" },
        { text: "total", sortable: false, align: "center", value: "total" }
      ],
      openReceiptModal: false,
      center: [initLat, initLng],
      marker: [initLat, initLng],
      purchaseStatus: purchaseStatus,
      userRoles: userRoles,
      zoom: 12,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    hasLocation() {
      return this.bill.latitude && this.bill.longitude;
    },
    classObject() {
      return {
        md6: this.bill.company || this.bill.dealer
      };
    },
    classDelivered() {
      return {
        md6:
          this.bill.purchase_status_id != this.purchaseStatus.PURCHASE_DELIVERED
      };
    },
    productExtras() {
      let extras = [];

      this.bill.details.forEach(detail => {
        extras = extras.concat(detail.extras);
      });


      return extras;
    }
  },
  created() {
    this.getBill();
  },
  methods: {
    getProductsWithExtras() {
      const { details } = this.bill || {};

      if( details ) {
        details.forEach(detail => {
          const { price, quantity, observation } = detail;
          const { name } = detail.product;

          this.productAndExtras.push({ 
            name,
            price,
            quantity,
            observation
          })

          detail.extras.forEach(extra => {
            const { price, quantity } = extra;
            const name = 'EXTRA - ' + extra.extra.name;

           this.productAndExtras.push({ 
              name,
              price,
              quantity,
              observation: ""
            })
          })

        })
      }
    },
    getBill() {
      this.billId = this.$route.params.id;
      this.$store
        .dispatch(GET_SHOPPING, this.billId)
        .then(res => {
          this.bill = res;
          this.getProductsWithExtras();

          this.center = [this.bill.latitude, this.bill.longitude];
          this.marker = [this.bill.latitude, this.bill.longitude];
        })
        .catch(err => {
          console.log(err);
        });
    },
    totalPrice() {
      let total = 0;

      this.bill.details.forEach(detail => {
        total += detail.price * detail.quantity;
      });

      this.productExtras.forEach(extra => {
        total += extra.quantity * extra.extra.price;
      });

      if (this.bill.delivery_price) total += Number(this.bill.delivery_price);

      return total;
    },
    onReceipt() {
      this.$refs.receiptModal.setValue(this.bill.full_url_image);
      this.openReceiptModal = true;
    },
    async onConfirmDelivery() {
      this.confirmDeliveryLoading = true;
      await this.$store.dispatch(CONFIRM_DELIVERY, this.billId);
      await this.$store
        .dispatch(GET_SHOPPING, this.billId)
        .then(res => {
          this.bill = res;
          this.confirmDeliveryLoading = false;

          //this.$router.push("/shopping-list");
        })
        .catch(err => {
          console.log(err);
        });
    },
    async onConfirmPayment() {
      this.confirmPaymentLoading = true;
      await this.$store.dispatch(CONFIRM_PAYMENT, this.billId);
      await this.$store
        .dispatch(GET_SHOPPING, this.billId)
        .then(res => {
          this.bill = res;
          this.confirmPaymentLoading = false;

          //this.$router.push("/shopping-list");
        })
        .catch(err => {
          console.log(err);
        });
    },
    async onDenyPayment() {
      await this.$store.dispatch(DENY_SHOPPING, this.billId);
      this.$store
        .dispatch(GET_SHOPPING, this.billId)
        .then(res => {
          this.bill = res;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.v-alert {
  margin: 4px 0;
}
.receipt-image {
  height: 14em;
  max-width: 10em;
  cursor: pointer;
  border: 1px solid black;
}

.map-style {
  height: 16em !important;
  z-index: 1 !important;
}
</style>
